(ns ycweb.util.shapes
  (:require
   [ycweb.util.core :as u]
   [util.string :as str]))

(defn clean-email [email]
  (when (u/presence email)
    (->
      email
      (str/replace #"\.{2,}" ".")
      (str/trim)
      (str/lower-case))))

(def email-validate
  #"(?i)^[A-Z0-9._%+!\"-]+@[A-Z0-9.-]+[.][A-Z]{2,}$")

(defn clean-tel [tel]
  (let [tel-number (str/replace tel #"[^0-9]" "")]
    (->
      tel-number
      ((fn [x]
         (cond
           (= (str/subs x 0 2) "00")
           (str/subs x 0 2)

           :else
           x)))
      ((fn [x]
         (cond
           (= (str/subs x 0 2) "27")
           (str "0" (str/subs x 0 2))

           :else
           x)))
      ((fn [x]
         (cond
           (= (str/subs x 0 2) "00")
           (str "0" (str/subs x 0 1))

           :else
           x))))))
